import { render, staticRenderFns } from "./Realnameauth.vue?vue&type=template&id=5809c164&scoped=true"
import script from "./Realnameauth.vue?vue&type=script&lang=js"
export * from "./Realnameauth.vue?vue&type=script&lang=js"
import style0 from "./Realnameauth.vue?vue&type=style&index=0&id=5809c164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809c164",
  null
  
)

export default component.exports